export default __webpack_public_path__ + "static/media/lp_logo.8776a602.svg";